export default __webpack_public_path__ + "static/media/clear_night.2df803f0.svg";